import { render, staticRenderFns } from "./PersonalizarEmailAniversarioDialog.vue?vue&type=template&id=617bc61d&"
import script from "./PersonalizarEmailAniversarioDialog.vue?vue&type=script&lang=js&"
export * from "./PersonalizarEmailAniversarioDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports